/** Sidebar verde oscuro fija. Módulos SEGÚN LOS PERMISOS DEL USUARIO (plantilla del rol + propios) — sin selector de sucursal. */
import { modulosPara, type PermisosEfectivos, type Rol } from '@mg/shared';
import {
  ArrowLeftRight,
  Banknote,
  BarChart3,
  BookOpen,
  Boxes,
  ClipboardList,
  CreditCard,
  FileText,
  Landmark,
  LayoutDashboard,
  Package,
  PackageCheck,
  Receipt,
  RotateCcw,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Layers,
  SlidersHorizontal,
  Store,
  Truck,
  Undo2,
  Users,
  Wallet,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import { NavLink } from 'react-router';
import { cn } from '@/lib/utils.ts';

const ICONOS: Record<string, LucideIcon> = {
  panel: LayoutDashboard,
  pos: ShoppingCart,
  cotizaciones: FileText,
  documentos: Receipt,
  entregas: PackageCheck,
  devoluciones: Undo2,
  productos: Package,
  inventario: Boxes,
  ajustes: SlidersHorizontal,
  roturas: Layers,
  traslados: Truck,
  flota: Wrench,
  compras: ClipboardList,
  gastos: Banknote,
  retenciones: RotateCcw,
  clientes: Users,
  'pagos-recibidos': Landmark,
  caja: Wallet,
  cierres: CreditCard,
  autorizaciones: ShieldCheck,
  reportes: BarChart3,
  libros: BookOpen,
  auditoria: ArrowLeftRight,
  consolidado: Store,
  configuracion: Settings,
};

export function Sidebar({ rol, permisos, sucursal }: { rol: Rol; permisos?: PermisosEfectivos | undefined; sucursal: string | null }) {
  const modulos = modulosPara({ rol, permisos });
  return (
    <aside className="no-print flex h-full w-60 shrink-0 flex-col bg-sidebar text-sidebar-foreground" data-testid="sidebar">
      <div className="flex items-center gap-3 px-4 py-4">
        <div className="rounded-xl bg-white p-1.5 shadow-sm">
          <img src="/logo-mg.png" alt="Materiales y Decoraciones MG" className="h-9 w-9 object-contain" />
        </div>
        <div className="leading-tight">
          <p className="text-sm font-bold text-white">MG ERP</p>
          <p className="text-[11px] text-sidebar-foreground/80">{sucursal ?? 'Consola global'}</p>
        </div>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto px-2 pb-4" aria-label="Módulos">
        {modulos.map((m) => {
          const Icono = ICONOS[m.id] ?? Package;
          return (
            <NavLink
              key={m.id}
              to={m.ruta}
              end={m.ruta === '/'}
              data-testid={`nav-${m.id}`}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] font-medium transition-colors hover:bg-white/10 hover:text-white',
                  isActive && 'bg-sidebar-activo text-white',
                )
              }
            >
              <Icono className="h-4 w-4 shrink-0" aria-hidden />
              <span className="truncate">{m.titulo}</span>
            </NavLink>
          );
        })}
      </nav>
      <div className="px-4 py-3 text-[10px] text-sidebar-foreground/60">Materiales y Decoraciones MG · v0.1</div>
    </aside>
  );
}
